import { gql } from '@apollo/client';
import React from 'react';
import { Expandable } from '@moda/om';
import { ProductDetailsExpandedFragment } from '../../generated/types/ProductDetailsExpandedFragment';
import { ProductDetailsExpandedVariantFragment } from '../../generated/types/ProductDetailsExpandedVariantFragment';
import { ProductDetailsShippingAndReturns } from './ProductDetailsShippingAndReturns';

export const PRODUCT_DETAILS_EXPANDED_FRAGMENT = gql`
  fragment ProductDetailsExpandedFragment on Variant {
    description
    descriptionText: description_text
    fitBrand: fit_brand
    shippingRestrictions: shipping_restrictions
    productId: product_id
    detailBullets: detail_bullets
    isBoutique: is_boutique
    masterVariantId: master_variant_id
  }
`;

export const PRODUCT_DETAILS_EXPANDED_VARIANT_FRAGMENT = gql`
  fragment ProductDetailsExpandedVariantFragment on VariantData {
    returnPolicy: return_policy
  }
`;

interface Props {
  activeVariant: ProductDetailsExpandedVariantFragment;
  variant: ProductDetailsExpandedFragment;
}

export const ProductDetailsExpanded: React.FC<Props> = ({
  activeVariant: { returnPolicy },
  variant: { detailBullets, fitBrand, productId, shippingRestrictions }
}) => {
  return (
    <>
      <Expandable name="PRODUCT DETAILS" expanded>
        <div dangerouslySetInnerHTML={{ __html: detailBullets || '' }} />
        <p>Product Code {productId}</p>
      </Expandable>

      <Expandable name="SIZE &amp; FIT">
        <div dangerouslySetInnerHTML={{ __html: fitBrand || '' }} />
      </Expandable>

      <Expandable name="SHIPPING &amp; RETURNS" expanded>
        <ProductDetailsShippingAndReturns
          shippingRestrictions={shippingRestrictions}
          returnPolicy={returnPolicy}
        />
      </Expandable>
    </>
  );
};
